import styled from 'styled-components';
import ViewContainer from './ViewContainer';

const CenteredViewContainer = styled(ViewContainer)`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
`

export default CenteredViewContainer;